module.exports = __webpack_public_path__ + "img/layout4.0201cdca.png";